import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ShowCoupon from "../../../components/SuperAdmin/Coupon/ShowCoupon";

export default withRouter(connect()(ShowCoupon));
